<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <router-link :to="{ name: 'CpEngagementDetails', params: {  id: $route.query.cp_id }, query: {credit_date_from: this.$route.query.credit_date_from, credit_date_upto: this.$route.query.credit_date_upto,status: this.$route.query.status}}" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
        </router-link>
         <a href="javascript:void(0);" class="link-title">{{this.broker_name ? this.broker_name + ' Details' : ''}}</a>
      </nav>
    </div>
    <div class="inner-page animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6" >
                                    <span class="enq-title">Date</span>
                                    <span class="enq-details">{{engagements.credit_date || '-'}}</span>
                                </div>
                                <div class="col-6">
                                    <span class="enq-title">Amount</span>
                                    <span class="enq-details">{{engagements.amount || '-'}}</span>
                                </div>
                                <div class="col-12">
                                    <span class="enq-title">Comment</span>
                                    <span class="enq-details">{{engagements.comment || '-'}}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
export default {
  name: 'Details',
  data() {
    return {
      engagements: {},
      broker_name: '',
      queryP: {},
      collection_count:'',
    }
  },
  created () {
    this.get_cp_details()
  },
  methods: {
    get_cp_details() {
      this.queryP['id'] = this.$route.params.id;
      this.$axios.get(`brokers/cp_engagement_detail/${this.queryP.id}`).then((res) => {
          this.engagements =  res.data.broker_engagement
          this.broker_name = res.data.broker
          this.queryP = {}
      });
    },
  }
}
</script>
<style scoped>
    .inner-page{
        margin-top: 60px;
    }
    .call-loading-holder img{
        max-width: 500px;
        margin:0 auto;
        display: table;
    }
</style>